import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;

	> h1 {
		color: ${color.interface.darkgray};
		font-size: 2rem;
		margin-bottom: 0.5rem;
	}
`;

export const line = styled.div`
	width: 100%;
	min-height: 1px;
	margin-top: 1rem;
	background-color: ${color.interface.lightGray2};
`;
